import { useAuth } from './auth/useAuth';
import { IdentityProvider } from './auth/useIdentity';
import { Outlet } from 'react-router-dom';

import './App.scss';
import { AppHeader } from './components/AppHeader/AppHeader';
import { ApiAccessNotice } from './components/ApiAccess/ApiAccessNotice';
import { AxiosProvider } from './hooks/useAxiosSwagger';
import { AlertsProvider } from './hooks/useAlerts';
import { AlertToasts } from './components/Alerts/Alerts';
import { BusyProvider } from './hooks/useBusy';
import { GlobalBusyBar } from './components/Loading/Loading';

// fontawesome
import { initFontAwesome } from './utils/initFontAwesome';
import { useEffect } from 'react';
initFontAwesome();

export const App = () => {
    const { isLoading, error, isAuthenticated, loginWithRedirect } = useAuth();

    useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            /*
                The page someone opened travels along as appState: Auth0 always returns
                to the origin, and the provider in index.tsx navigates back to returnTo
                once the round trip is done. window.location rather than useLocation, so
                the effect cannot fire with a route that has gone stale.
            */
            loginWithRedirect({
                appState: {
                    returnTo:
                        window.location.pathname + window.location.search,
                },
            });
        }
    }, [isLoading])

    return (
        <AxiosProvider>
            {/*
                Inside AxiosProvider, because the roles are asked for over the same axios
                instance and only make sense once there is a token to ask with. Around the
                whole app rather than around the one screen that reads them, so the question
                is asked once per sign-in instead of once per navigation.
            */}
            <IdentityProvider>
                {/*
                    Inside the identity: the alerts are for admins only, and the provider asks
                    who is signed in before it connects to anything.
                */}
                <AlertsProvider>
                <BusyProvider>
                <GlobalBusyBar />
                <AlertToasts />
                <div className="App">
                    <AppHeader />
                    <div className="container">
                        <div className="col">
                            {/* {(!isLoading && !isAuthenticated) && (
                            <div className='text-center login-container'>
                                <h3 className='mb-2'>Aanmelden</h3>
                                <div>
                                    <ButtonLogin></ButtonLogin>
                                </div>
                            </div>
                        )} */}

                            {!isAuthenticated && isLoading && <b>Loading</b>}

                            {/*
                                The notice sits inside the signed-in branch on purpose.
                                Before the login round-trip there is no token by design, and
                                a banner about a missing one would only flash past on the
                                way to Auth0.
                            */}
                            {!isLoading && isAuthenticated && (
                                <>
                                    <ApiAccessNotice />
                                    <Outlet />
                                </>
                            )}

                            {error && <div>Oops... {error.message}</div>}
                        </div>
                    </div>
                    <footer></footer>
                </div>
                </BusyProvider>
                </AlertsProvider>
            </IdentityProvider>
        </AxiosProvider>
    );
};
